import { InputContainer } from '@creditornot/cb-form';
import { Input } from '@creditornot/cb-input';
import { Select } from '@creditornot/cb-select';
import React, { useCallback, useState } from 'react';
import { Field } from 'react-final-form';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { RFFFieldErrorWrapper } from 'common/components';

type BusinessAddressFieldsProps = {
  cityOptions: {
    label: string;
    value: string;
  }[];
};

const CityAndPostCode = styled.div`
  margin-block-start: 8px;
  margin-block-end: 16px;
  display: flex;
`;

const PostCode = styled(InputContainer)`
  flex: 0 0 50%;
  margin-inline-end: 8px;
`;

const City = styled(InputContainer)`
  flex: 1 1 auto;
`;

const OtherCity = styled(InputContainer)`
  margin-block-start: 8px;
  margin-block-end: 16px;
`;

function BusinessAddressFields({ cityOptions }: BusinessAddressFieldsProps) {
  const intl = useIntl();
  const [selectedCity, setSelectedCity] = useState<string | null>('');

  const t = useCallback((id: string) => intl.formatMessage({ id }), [intl]);

  const renderCityOptions = [
    ...cityOptions,
    {
      label: t('self-serve-sign-up.form-labels.venues.other-city'),
      value: 'other',
    },
  ];

  return (
    <>
      <InputContainer label="Street address" labelHtmlFor="onboarding-wizard-form-venue-venues-address">
        <Field<string | undefined> name="businessAddress">
          {field => (
            <RFFFieldErrorWrapper field={field}>
              {input => <Input {...input} id="onboarding-wizard-form-venue-venues-address" />}
            </RFFFieldErrorWrapper>
          )}
        </Field>
      </InputContainer>

      <CityAndPostCode data-testid="onboarding-wizard-sign-up-venues-city">
        <PostCode label="Postal code" labelHtmlFor="onboarding-wizard-form-venue-venues-postCode">
          <Field<string | undefined> name="businessPostCode">
            {field => (
              <RFFFieldErrorWrapper field={field}>
                {input => <Input {...input} id="onboarding-wizard-form-venue-venues-postCode" />}
              </RFFFieldErrorWrapper>
            )}
          </Field>
        </PostCode>

        <City label="City">
          <Field<string | null> name="businessCity">
            {field => (
              <RFFFieldErrorWrapper field={field}>
                {input => (
                  <Select
                    inputId="city"
                    options={renderCityOptions}
                    placeholder=""
                    {...input}
                    onChange={newValue => {
                      input.onChange(newValue);
                      setSelectedCity(newValue);
                    }}
                  />
                )}
              </RFFFieldErrorWrapper>
            )}
          </Field>
        </City>
      </CityAndPostCode>

      {selectedCity === 'other' && (
        <OtherCity label="Other city" labelHtmlFor="onboarding-wizard-form-venue-venues-otherCity">
          <Field<string | undefined> name="businessAddress.otherCity">
            {field => (
              <RFFFieldErrorWrapper field={field}>
                {input => <Input {...input} id="onboarding-wizard-form-venue-venues-otherCity" />}
              </RFFFieldErrorWrapper>
            )}
          </Field>
        </OtherCity>
      )}
    </>
  );
}

export default BusinessAddressFields;
